module.exports = __webpack_public_path__ + "img/tanker_black.6a24d3aa.svg";